import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class StorageLocalService {

    setWithExpiry(key: string, value: any, expiryHours: number = 24): void {
        const item = {
            value: value,
            expiry: Date.now() + (expiryHours * 60 * 60 * 1000)
        };
        localStorage.setItem(key, JSON.stringify(item));
    }

    getWithExpiry(key: string): any {
        const itemStr = localStorage.getItem(key);
        if (!itemStr) return null;

        try {
            const item = JSON.parse(itemStr);
            if (Date.now() < item.expiry) {
                return item.value;
            }

            localStorage.removeItem(key);
            return null;
        } catch {
            return null;
        }
    }

    setAutocompleteRecognition(): void {
        this.setWithExpiry('autocomplete_recognition', true, 1);
    }

    getAutocompleteRecognition(): boolean {
        return this.getWithExpiry('autocomplete_recognition') === true;
    }

    clearExpiredItems(): void {
        const keys = Object.keys(localStorage);
        keys.forEach(key => {
            this.getWithExpiry(key);
        });
    }
}